export default "__VITE_ASSET__BIXA95MP__"